/* marleys FINAL homepage behaviour (Oct 2026). Loaded once by every hf-* section. */
(function () {
  if (window.__hfHome) return;
  window.__hfHome = true;

  var desktop = window.matchMedia('(min-width: 990px)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function headerOffset() {
    var h = document.querySelector('.shopify-section-group-header-group .header, #header');
    return (h ? h.getBoundingClientRect().height : 64) + 8;
  }

  /* ---------- videos: one with sound at a time ---------- */
  function pauseAll(except) {
    $$('.hf video').forEach(function (v) {
      if (v === except || v.closest('.hf-hero')) return;
      if (!v.paused) v.pause();
      var holder = v.closest('.is-playing');
      if (holder) { holder.classList.remove('is-playing'); holder.classList.add('is-paused'); }
    });
  }

  /* ---------- in-page links ---------- */
  function openDancers() {
    var d = $('[data-hf-dancers]');
    if (!d) return;
    d.classList.add('is-open');
    var more = $('[data-hf-more]', d);
    if (more) { more.setAttribute('aria-expanded', 'true'); more.textContent = more.dataset.less; }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-hf-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    if (a.hasAttribute('data-hf-open-dancers')) openDancers();
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    if (history.replaceState) history.replaceState(null, '', href);
  });

  /* ---------- trust bar slider (mobile) ---------- */
  function initTrust(root) {
    var row = $('.hf-trust__row', root);
    var items = $$('.hf-trust__item', row);
    if (items.length < 4) return;
    items.slice(0, 3).forEach(function (it) {
      var c = it.cloneNode(true); c.setAttribute('data-clone', ''); c.setAttribute('aria-hidden', 'true'); row.appendChild(c);
    });
    var i = 0, n = items.length, timer = null;
    var ms = (parseInt(root.dataset.interval, 10) || 3) * 1000;
    function step() {
      if (desktop.matches || reduceMotion.matches || document.hidden) return;
      i += 1;
      row.style.transition = '';
      row.style.transform = 'translateX(' + (-i * 100 / 3) + '%)';
      if (i === n) {
        setTimeout(function () { row.style.transition = 'none'; row.style.transform = 'translateX(0)'; i = 0; }, 650);
      }
    }
    timer = setInterval(step, ms);
    desktop.addEventListener && desktop.addEventListener('change', function () { row.style.transition = 'none'; row.style.transform = ''; i = 0; });
  }

  /* ---------- swipe rows with dots ---------- */
  function initSwipe(track) {
    var wrap = track.parentElement;
    var dotsEl = $('[data-hf-dots]', wrap);
    if (!dotsEl) return;
    var kids = Array.prototype.slice.call(track.children);
    function stops() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) return [];
      var base = kids[0].offsetLeft, out = [];
      kids.forEach(function (k) { var x = k.offsetLeft - base; if (x < max - 2) out.push(x); });
      out.push(max);
      return out;
    }
    var pos = [];
    function build() {
      pos = stops();
      dotsEl.innerHTML = '';
      dotsEl.style.display = pos.length > 1 ? '' : 'none';
      pos.forEach(function (x, idx) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'hf-dot'; b.tabIndex = -1;
        b.addEventListener('click', function () { track.scrollTo({ left: x, behavior: 'smooth' }); });
        dotsEl.appendChild(b);
      });
      update();
    }
    function update() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      pos.forEach(function (p, idx) { var dd = Math.abs(p - x); if (dd < d) { d = dd; best = idx; } });
      $$('.hf-dot', dotsEl).forEach(function (b, idx) { b.classList.toggle('is-active', idx === best); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth === lastW) return; lastW = window.innerWidth; build(); });
    build();
  }

  /* ---------- zoom lightbox ---------- */
  var zoom;
  function openZoom(src, alt) {
    if (!zoom) {
      zoom = document.createElement('div');
      zoom.className = 'hf hf-zoom';
      zoom.setAttribute('role', 'dialog');
      zoom.setAttribute('aria-modal', 'true');
      zoom.setAttribute('aria-label', 'Zoomed photo');
      zoom.innerHTML = '<img alt=""><button type="button" class="hf-zoom__close" aria-label="Close">×</button>';
      document.body.appendChild(zoom);
      zoom.addEventListener('click', closeZoom);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeZoom(); });
    }
    var img = zoom.querySelector('img');
    img.src = src; img.alt = alt || '';
    zoom.classList.add('is-open');
    zoom.querySelector('.hf-zoom__close').focus();
  }
  function closeZoom() { if (zoom) zoom.classList.remove('is-open'); }

  /* ---------- product tiles ---------- */
  function initTile(tile) {
    var variants = [], colours = {};
    try { variants = JSON.parse($('[data-variants]', tile).textContent); } catch (e) {}
    try { colours = JSON.parse($('[data-colours]', tile).textContent); } catch (e) {}
    var stage = $('[data-stage]', tile);
    var items = $$('.hf-stage__item', stage);
    var thumbsEl = $('[data-thumbs]', tile);
    var thumbs = $$('.hf-thumb', thumbsEl);
    var counter = $('[data-counter]', tile);
    var tabs = $$('.hf-tab', tile);
    var buy = $('[data-buy]', tile);
    var msg = $('[data-buy-msg]', tile);
    var state = { colour: null, size: null, visible: [] };
    var firstPressed = $('.hf-swatch[aria-pressed="true"]', tile) || $('.hf-swatch', tile);

    function findVariant(c, s) {
      for (var k = 0; k < variants.length; k++) if (variants[k].colour === c && variants[k].size === s) return variants[k];
      return null;
    }
    function visibleItems() { return items.filter(function (it) { return !it.hidden; }); }
    function currentIndex() {
      var vis = visibleItems(), x = stage.scrollLeft, w = stage.clientWidth || 1;
      return Math.min(vis.length - 1, Math.max(0, Math.round(x / w)));
    }
    function updateCounter() {
      var vis = visibleItems(), idx = currentIndex();
      if (counter) counter.textContent = (idx + 1) + ' / ' + vis.length;
      var activeI = vis[idx] ? vis[idx].dataset.i : null;
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.i === activeI); });
    }
    function goTo(i, smooth) {
      var vis = visibleItems();
      var pos = vis.findIndex(function (it) { return it.dataset.i === String(i); });
      if (pos < 0) return;
      stage.scrollTo({ left: pos * stage.clientWidth, behavior: smooth && !reduceMotion.matches ? 'smooth' : 'auto' });
      setTimeout(updateCounter, smooth ? 350 : 0);
      updateCounter();
    }
    function layoutThumbs() {
      var vis = thumbs.filter(function (t) { return !t.hidden; });
      thumbs.forEach(function (t) { t.classList.remove('is-overflow', 'is-last-visible'); });
      if (vis.length > 6) {
        vis.forEach(function (t, k) { if (k > 5) t.classList.add('is-overflow'); });
        vis[5].classList.add('is-last-visible');
        var more = vis[5].querySelector('.hf-thumb__more');
        if (more) more.textContent = '+' + (vis.length - 6);
      }
    }
    function setColour(c) {
      state.colour = c;
      $$('.hf-swatch', tile).forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.colour === c ? 'true' : 'false'); });
      var nameEl = $('[data-colour-name]', tile); if (nameEl) nameEl.textContent = c;
      var info = colours[c] || {};
      var desc = $('[data-desc]', tile);
      if (desc) {
        desc.innerHTML = '';
        if (info.limited) { var pill = document.createElement('span'); pill.className = 'hf-pill-ltd'; pill.textContent = 'Limited edition'; desc.appendChild(pill); }
        desc.appendChild(document.createTextNode(info.desc || ''));
        desc.hidden = !info.desc && !info.limited;
      }
      items.forEach(function (it) { it.hidden = !(it.dataset.colour === 'all' || it.dataset.colour === c); });
      thumbs.forEach(function (t) { var it = items.filter(function (x) { return x.dataset.i === t.dataset.i; })[0]; t.hidden = !it || it.hidden; });
      thumbsEl.classList.remove('is-open');
      layoutThumbs();
      pauseAll();
      stage.scrollLeft = 0;
      updateCounter();
      tabs.forEach(function (t) {
        var v = findVariant(c, t.dataset.size);
        t.hidden = !v;
        t.disabled = !!v && !v.available;
      });
      if (state.size) {
        var v = findVariant(c, state.size);
        if (!v || !v.available) selectSize(null);
      }
      refreshBuy();
    }
    var sizeLabel = $('[data-size-label]', tile);
    function selectSize(s) {
      state.size = s;
      if (sizeLabel) {
        var chosen = s ? tabs.filter(function (t) { return t.dataset.size === s; })[0] : null;
        sizeLabel.textContent = chosen ? (sizeLabel.dataset.prefix || 'Size') + ' · ' + chosen.textContent.trim() : sizeLabel.dataset.empty;
      }
      tabs.forEach(function (t) { t.setAttribute('aria-checked', t.dataset.size === s ? 'true' : 'false'); t.tabIndex = (t.dataset.size === s || (!s && t === tabs.filter(function (x) { return !x.hidden && !x.disabled; })[0])) ? 0 : -1; });
      refreshBuy();
    }
    /* Oct 20: the buttons look disabled until a size is picked but stay clickable (aria-disabled),
       so a tap points the shopper at the sizes instead of showing the "not allowed" cursor. */
    function refreshBuy() {
      var v = state.size ? findVariant(state.colour, state.size) : null;
      var ok = !!(v && v.available);
      buy.disabled = false;
      buy.setAttribute('aria-disabled', ok ? 'false' : 'true');
      buy.dataset.variant = ok ? v.id : '';
      if (msg) msg.textContent = '';
      if (ok && sizeLabel) sizeLabel.classList.remove('is-prompt');
    }
    function promptSize() {
      var panel = $('[data-size-panel]', tile);
      if (sizeLabel) sizeLabel.classList.add('is-prompt');
      if (msg) msg.textContent = (sizeLabel && sizeLabel.dataset.prompt) || 'Select your size first.';
      if (panel) {
        var y = panel.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 16;
        if (panel.getBoundingClientRect().top < headerOffset() || panel.getBoundingClientRect().bottom > window.innerHeight) window.scrollTo({ top: y, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      var first = tabs.filter(function (x) { return !x.hidden && !x.disabled; })[0];
      if (first) first.focus({ preventScroll: true });
    }
    tile.__hfPromptSize = promptSize;

    $$('.hf-swatch', tile).forEach(function (b) { b.addEventListener('click', function () { setColour(b.dataset.colour); }); });
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { if (!t.disabled) selectSize(t.dataset.size); });
      t.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };
        if (!(e.key in keys)) return;
        e.preventDefault();
        var live = tabs.filter(function (x) { return !x.hidden && !x.disabled; });
        var k = live.indexOf(t); var nx = live[(k + keys[e.key] + live.length) % live.length];
        if (nx) { nx.focus(); selectSize(nx.dataset.size); }
      });
    });
    var choose = $('[data-choose]', tile);
    if (choose) choose.addEventListener('click', function () {
      $('[data-size-panel]', tile).hidden = false;
      $('[data-cta]', tile).hidden = false;
      choose.hidden = true;
      var first = tabs.filter(function (x) { return !x.hidden && !x.disabled; })[0];
      if (first) first.focus({ preventScroll: true });
    });
    buy.addEventListener('click', function () {
      if (buy.getAttribute('aria-busy') === 'true') return;
      if (buy.getAttribute('aria-disabled') === 'true') { promptSize(); return; }
      var id = buy.dataset.variant;
      if (!id) return;
      var label = buy.textContent;
      buy.setAttribute('aria-busy', 'true');
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      /* Buy now = exactly ONE of this shoe at checkout. /cart/update.js SETS the
         quantity (adding the line if it isn't in the cart), so tapping again after
         coming back from checkout never stacks a second pair; other cart lines are
         left alone. Shopify answers .js endpoints as text/javascript, so parse the
         body instead of trusting the content-type (Oct 9 bug: that check sent every
         tap down the fallback path too, adding two). */
      var updates = {}; updates[id] = 1;
      fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) {
        return r.text().then(function (txt) {
          var data = null;
          try { data = JSON.parse(txt); } catch (e) { throw new Error('blocked'); } /* HTML = bot check / error page */
          if (!r.ok) { var err = new Error(data.description || data.message || 'Could not add to cart'); err.userFacing = true; throw err; }
          var line = (data.items || []).filter(function (it) { return String(it.variant_id) === String(id); })[0];
          if (!line) { var e2 = new Error('Sorry, that size just sold out.'); e2.userFacing = true; throw e2; }
          window.location.href = root + 'checkout';
        });
      }).catch(function (err) {
        if (err && err.userFacing) {
          buy.removeAttribute('aria-busy'); buy.textContent = label;
          if (msg) msg.textContent = err.message;
          return;
        }
        /* Only when the request itself was blocked or failed: a plain form post to
           /cart/update (sets quantity to 1, then checkout), which lets Shopify show its
           own verification page first. */
        var f = document.createElement('form');
        f.method = 'post'; f.action = root + 'cart/update'; f.style.display = 'none';
        [['updates[' + id + ']', '1'], ['return_to', root + 'checkout']].forEach(function (kv) {
          var i = document.createElement('input'); i.type = 'hidden'; i.name = kv[0]; i.value = kv[1]; f.appendChild(i);
        });
        document.body.appendChild(f); f.submit();
      });
    });

    stage.addEventListener('scroll', function () { window.requestAnimationFrame(updateCounter); }, { passive: true });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.classList.contains('is-last-visible') && desktop.matches && !thumbsEl.classList.contains('is-open')) thumbsEl.classList.add('is-open');
        goTo(t.dataset.i, !desktop.matches);
      });
      t.addEventListener('mouseenter', function () { if (desktop.matches) goTo(t.dataset.i, false); });
    });
    items.forEach(function (it) {
      if (it.hasAttribute('data-video')) {
        var v = it.querySelector('video');
        it.addEventListener('click', function () {
          if (v.paused) { pauseAll(v); v.muted = false; v.play(); it.classList.add('is-playing'); }
          else { v.pause(); it.classList.remove('is-playing'); }
        });
        v.addEventListener('ended', function () { it.classList.remove('is-playing'); });
      } else {
        it.addEventListener('click', function () { var img = it.querySelector('img'); openZoom(it.dataset.zoom, img ? img.alt : ''); });
      }
    });

    /* social proof faces: posters from the Dancers in marleys reels */
    var faces = $('[data-faces]', tile);
    if (faces) {
      var nums = (faces.dataset.faces || '').split(',').map(function (s) { return s.trim(); });
      var slots = $$('.hf-face', faces);
      nums.forEach(function (num, k) {
        var reelImg = document.querySelector('.hf-reel[data-reel="' + num + '"] img');
        if (reelImg && slots[k]) slots[k].style.backgroundImage = 'url("' + (reelImg.currentSrc || reelImg.src) + '")';
      });
    }

    setColour(firstPressed ? firstPressed.dataset.colour : (variants[0] && variants[0].colour));
    selectSize(null);
    window.addEventListener('resize', updateCounter);
  }

  /* ---------- dancers reels ---------- */
  function initDancers(root) {
    $$('.hf-reel', root).forEach(function (reel) {
      var v = reel.querySelector('video');
      if (!v) return;
      reel.addEventListener('click', function () {
        if (!v.src) {
          var canHls = v.dataset.hls && v.canPlayType('application/vnd.apple.mpegurl');
          v.src = canHls ? v.dataset.hls : v.dataset.src;
        }
        if (v.paused) {
          pauseAll(v); v.muted = false;
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          reel.classList.add('is-playing'); reel.classList.remove('is-paused');
          reel.setAttribute('aria-label', reel.getAttribute('aria-label').replace('Play', 'Pause'));
        } else {
          v.pause(); reel.classList.remove('is-playing'); reel.classList.add('is-paused');
          reel.setAttribute('aria-label', reel.getAttribute('aria-label').replace('Pause', 'Play'));
        }
      });
    });
    /* Phones: the reel nearest the centre is the "active" one; a playing reel that
       gets swiped away pauses. Start on the second reel so a peek shows on both sides. */
    var track = $('[data-hf-reels]', root);
    var reels = $$('.hf-reel', root);
    function markCentre() {
      if (desktop.matches || !track) { reels.forEach(function (r) { r.classList.remove('is-centre'); }); return; }
      var mid = track.getBoundingClientRect().left + track.clientWidth / 2, best = null, d = Infinity;
      reels.forEach(function (r) { var b = r.getBoundingClientRect(); var dd = Math.abs(b.left + b.width / 2 - mid); if (dd < d) { d = dd; best = r; } });
      reels.forEach(function (r) {
        var on = r === best;
        r.classList.toggle('is-centre', on);
        if (!on && r.classList.contains('is-playing')) { var vv = r.querySelector('video'); if (vv) vv.pause(); r.classList.remove('is-playing'); r.classList.add('is-paused'); }
      });
    }
    if (track) {
      track.addEventListener('scroll', function () { window.requestAnimationFrame(markCentre); }, { passive: true });
      window.addEventListener('resize', markCentre);
      if (!desktop.matches && reels[1]) {
        var startAt = reels[1];
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = startAt.offsetLeft - (track.clientWidth - startAt.offsetWidth) / 2;
        track.style.scrollBehavior = '';
      }
      markCentre();
      /* posters: load them all once the section is close, so swiping never shows blanks */
      if ('IntersectionObserver' in window) {
        var po = new IntersectionObserver(function (en) {
          if (!en[0].isIntersecting) return;
          po.disconnect();
          $$('img[loading="lazy"]', track).forEach(function (im) { im.loading = 'eager'; });
        }, { rootMargin: '900px 0px' });
        po.observe(root);
      }
    }
    var more = $('[data-hf-more]', root);
    if (more) more.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.dataset.less : more.dataset.more;
      if (!open) {
        var y = root.getBoundingClientRect().top + window.pageYOffset - headerOffset();
        if (y < window.pageYOffset) window.scrollTo({ top: y });
      }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting) $$('video', en.target).forEach(function (v) { if (!v.paused) { v.pause(); var r = v.closest('.hf-reel'); if (r) { r.classList.remove('is-playing'); r.classList.add('is-paused'); } } }); });
      }, { threshold: 0 }).observe(root);
    }
  }


  /* ---------- Shop Pay Installments line, from the store's live plans ---------- */
  function initInstalments() {
    $$('[data-hf-instal]').forEach(function (line) {
      var src = line.nextElementSibling && line.nextElementSibling.querySelector('shopify-payment-terms');
      if (src && !src.getAttribute('shopify-meta')) return;
      if (!src) { line.remove(); return; }
      var meta;
      try { meta = JSON.parse(src.getAttribute('shopify-meta')); } catch (e) { return; }
      var v = meta.variants && meta.variants[0];
      if (!v || v.eligible === false) { line.remove(); return; }
      var price = parseInt(line.dataset.price, 10) / 100;
      var best = null;
      (meta.financing_plans || []).forEach(function (plan) {
        if (price < plan.min_price_amount || price > plan.max_price_amount) return;
        (plan.terms || []).forEach(function (t) {
          if (Number(t.apr) === 0 && (!best || t.installments_count > best.installments_count)) best = t;
        });
      });
      if (!best) { line.remove(); return; }
      var per = Math.round(price / best.installments_count * 100) / 100;
      var amount;
      try { amount = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: meta.currency_code || line.dataset.currency, currencyDisplay: 'narrowSymbol' }).format(per); }
      catch (e) { amount = '$' + per.toFixed(2); }
      var textEl = line.querySelector('[data-hf-instal-text]') || line;
      textEl.textContent = (line.dataset.template || '').replace('[n]', best.installments_count).replace('[amount]', amount);
      var more = line.querySelector('[data-hf-terms-open]');
      if (more) {
        more.hidden = false;
        more.addEventListener('click', function () {
          var wrap = line.nextElementSibling;
          var host = wrap && wrap.querySelector('shopify-payment-terms');
          var cta = host && host.shadowRoot && host.shadowRoot.querySelector('#shopify-installments-cta, button[aria-haspopup="dialog"]');
          if (!cta) return;
          wrap.removeAttribute('inert');
          cta.click();
          setTimeout(function () { wrap.setAttribute('inert', ''); }, 0);
        });
      }
    });
  }


  /* ---------- Size guide drawer (product tiles) ----------
     The tile's "Size & fit guide" opens the SAME drawer the product page uses:
     the shoe's product page is fetched once (in the background when the tile
     scrolls into view), its <menu-drawer class="product__size-guide"> is lifted
     out and mounted in the tile, and the theme's own MenuDrawer component
     (global.js) opens it. If anything fails, the link just goes to the page. */
  var sgCache = {};
  function sgLoad(url) {
    if (!sgCache[url]) {
      sgCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var d = doc.querySelector('menu-drawer.product__size-guide');
        if (!d) throw new Error('no size guide drawer');
        return d.outerHTML;
      });
      sgCache[url].catch(function () { delete sgCache[url]; });
    }
    return sgCache[url];
  }
  function sgMount(tile, html) {
    var slot = $('[data-hf-sg-slot]', tile);
    if (!slot) return null;
    if (slot.firstElementChild) return slot.firstElementChild;
    var key = (tile.id || 'tile').replace(/[^a-z0-9_-]/gi, '');
    slot.innerHTML = html.replace(/Size-Guide-/g, 'Size-Guide-' + key + '-');
    $$('script', slot).forEach(function (old) {
      var sc = document.createElement('script');
      sc.textContent = old.textContent;
      old.replaceWith(sc);
    });
    return slot.firstElementChild;
  }
  function sgPrepare(tile) {
    var link = $('a[data-hf-sizeguide]', tile);
    var url = link && link.dataset.productUrl;
    if (!url) return Promise.reject();
    return sgLoad(url).then(function (html) { return sgMount(tile, html); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-hf-sizeguide]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var tile = a.closest('[data-hf-tile]');
    if (!tile || !a.dataset.productUrl) return;
    e.preventDefault();
    sgPrepare(tile).then(function (drawer) {
      var summary = drawer && drawer.querySelector('summary');
      if (!summary) throw new Error('no summary');
      requestAnimationFrame(function () { summary.click(); });
    }).catch(function () { window.location.href = a.getAttribute('href'); });
  });
  function sgWarm() {
    var tiles = $$('[data-hf-tile]');
    if (!('IntersectionObserver' in window)) { tiles.forEach(function (t) { sgPrepare(t).catch(function () {}); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        sgPrepare(en.target).catch(function () {});
      });
    }, { rootMargin: '400px 0px' });
    tiles.forEach(function (t) { io.observe(t); });
  }

  /* ---------- accordions: slide open / closed instead of snapping; one open at a time per list ---------- */
  var EASE = 'cubic-bezier(.4, 0, .2, 1)', DUR = 420;
  function accClose(d) {
    var body = d.querySelector('.hf-faq__answer');
    if (!d.open || d.classList.contains('is-closing')) return;
    if (reduceMotion.matches || !body || !body.animate) { d.open = false; return; }
    if (d._hfAnim) d._hfAnim.cancel();
    var pad = parseFloat(getComputedStyle(body).paddingBottom) || 0, h = body.offsetHeight;
    d.classList.add('is-closing');
    var a = d._hfAnim = body.animate([{ height: h + 'px', paddingBottom: pad + 'px', opacity: 1 }, { height: '0px', paddingBottom: '0px', opacity: 0 }], { duration: DUR, easing: EASE });
    a.onfinish = function () { d.open = false; d.classList.remove('is-closing'); d._hfAnim = null; };
  }
  function accOpen(d) {
    var body = d.querySelector('.hf-faq__answer');
    var group = d.parentElement;
    $$('details.hf-faq__item', group).forEach(function (o) { if (o !== d && o.parentElement === group) accClose(o); });
    if (d._hfAnim) { d._hfAnim.cancel(); d._hfAnim = null; }
    d.classList.remove('is-closing');
    d.open = true;
    if (reduceMotion.matches || !body || !body.animate) return;
    var pad = parseFloat(getComputedStyle(body).paddingBottom) || 0, h = body.offsetHeight;
    var a = d._hfAnim = body.animate([{ height: '0px', paddingBottom: '0px', opacity: 0 }, { height: h + 'px', paddingBottom: pad + 'px', opacity: 1 }], { duration: DUR, easing: EASE });
    a.onfinish = function () { d._hfAnim = null; };
  }
  function initAccordions() {
    $$('.hf details.hf-faq__item').forEach(function (d) {
      if (d.dataset.hfAnim) return;
      d.dataset.hfAnim = '1';
      var summary = d.querySelector('summary');
      if (!summary) return;
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (d.open && !d.classList.contains('is-closing')) accClose(d); else accOpen(d);
      });
    });
  }

  function init() {
    initAccordions();
    initInstalments();
    sgWarm();
    $$('[data-hf-trust]').forEach(initTrust);
    $$('[data-hf-dancers]').forEach(initDancers);
    $$('[data-hf-tile]').forEach(initTile);
    $$('[data-hf-swipe]').forEach(initSwipe);
    if (location.hash === '#dancers') openDancers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__hfHome = false; });

  /* Back button (Oct 20). Browsers restore the page from the back-forward cache exactly as
     it was left, so after Buy now → checkout → Back the button was still spinning, and after
     a country change → Back the page showed the old country's prices. On a restore: stop
     the spinner, and reload if the page was rendered for a different country than the
     shopper has now picked (html[data-market] vs the localization cookie). */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var m = document.cookie.match(/(?:^|;\s*)localization=([A-Z]{2})/);
    var picked = m ? (m[1] === 'CA' ? 'CA' : 'US') : null;
    var shown = document.documentElement.getAttribute('data-market');
    if (picked && shown && picked !== shown) { window.location.reload(); return; }
    Array.prototype.forEach.call(document.querySelectorAll('[data-buy][aria-busy="true"]'), function (b) {
      b.removeAttribute('aria-busy');
    });
  });
})();
